module.exports = __webpack_public_path__ + "img/icon_church.d1a85ae1.svg";